module.exports = __webpack_public_path__ + "img/mission-clear.948a6f13.png";